import { usePersonalisation } from 'hooks/usePersonalisation';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getPropertyId } from 'store/property/propertySelectors';

export function useTrackPropertyPageView() {
  const propertyId = useSelector(getPropertyId);
  const personalisation = usePersonalisation();
  useEffect(() => {
    personalisation.trackView(propertyId);
  }, [personalisation, propertyId]);
}
